import { render, staticRenderFns } from "./sale-invoice-pos.vue?vue&type=template&id=5044f8e6&scoped=true&"
import script from "./sale-invoice-pos.vue?vue&type=script&lang=js&"
export * from "./sale-invoice-pos.vue?vue&type=script&lang=js&"
import style0 from "./sale-invoice-pos.vue?vue&type=style&index=0&id=5044f8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044f8e6",
  null
  
)

export default component.exports